import { getLocalStorage, setLocalStorage } from '@/common/localStorages';

/**
 * Extracts UTM parameters from a query string and returns them as a formatted query string.
 *
 * @param search - The query string to extract UTM parameters from.
 * @returns A formatted query string containing only UTM parameters.
 */
export const getUTMQueryString = (search: string): string => {
  const urlParams = new URLSearchParams(search);
  const utmQueryString = Array.from(urlParams.entries())
    .filter(([key]) => /^utm_/.test(key))
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  return utmQueryString;
};

/**
 * Saves the given UTM string to local storage.
 *
 * @param value - The UTM string to be saved in the local storage.
 */
export const saveUTMStringToLocalStorage = (value: string): void => {
  setLocalStorage('utmParams', value);
};

/**
 * Retrieves the UTM parameters string from the local storage.
 *
 * @returns {string | null} The UTM parameters string if found, otherwise null.
 */
export const getUTMStringFromLocalStorage = (): string | null => {
  return getLocalStorage('utmParams');
};

/**
 * Compares the given UTM string with the one stored in local storage.
 *
 * @param value - The UTM string to compare with the stored value.
 * @returns True if the given string matches the stored value, false otherwise.
 */
export const compareUTMStringWithLocalStorage = (value: string): boolean => {
  const storedValue = getLocalStorage('utmParams');
  return storedValue === value;
};
